export const REFERRAL_FORM_GET_REQUEST = 'REFERRAL_FORM_GET_REQUEST';
export const REFERRAL_FORM_GET_SUCCESS = 'REFERRAL_FORM_GET_SUCCESS';
export const REFERRAL_FORM_GET_ERROR = 'REFERRAL_FORM_GET_ERROR';
export const REFERRAL_FORM_GET_BY_KEY_REQUEST = 'REFERRAL_FORM_GET_BY_KEY_REQUEST';
export const REFERRAL_FORM_GET_BY_KEY_SUCCESS = 'REFERRAL_FORM_GET_BY_KEY_SUCCESS';
export const REFERRAL_FORM_GET_BY_KEY_ERROR = 'REFERRAL_FORM_GET_BY_KEY_ERROR';
export const REFERRAL_FORM_ADD_REQUEST = 'REFERRAL_FORM_ADD_REQUEST';
export const REFERRAL_FORM_ADD_SUCCESS = 'REFERRAL_FORM_ADD_SUCCESS';
export const REFERRAL_FORM_ADD_ERROR = 'REFERRAL_FORM_ADD_ERROR';
export const REFERRAL_FORM_EDIT_REQUEST = 'REFERRAL_FORM_EDIT_REQUEST';
export const REFERRAL_FORM_EDIT_SUCCESS = 'REFERRAL_FORM_EDIT_SUCCESS';
export const REFERRAL_FORM_EDIT_ERROR = 'REFERRAL_FORM_EDIT_ERROR';
export const REFERRAL_FORM_DELETE_REQUEST = 'REFERRAL_FORM_DELETE_REQUEST';
export const REFERRAL_FORM_DELETE_SUCCESS = 'REFERRAL_FORM_DELETE_SUCCESS';
export const REFERRAL_FORM_DELETE_ERROR = 'REFERRAL_FORM_DELETE_ERROR';
